import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Card,
  Space,
  InputNumber,
  Switch,
  Descriptions,
} from 'antd';
import { StoreContext } from '../store/index';
import { updateShift } from './api';
import { getDateFromTimestamp } from '../utils';

function BookShiftModal({ shift, visible, onClose }) {
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;

  const { startDate, placeName, address, placeSport, totalPlayers } = shift;
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [isPublic, setIsPublic] = useState(true);

  useEffect(() => {
    form.setFieldsValue({
      confirmedPlayers: totalPlayers,
    });
  }, []);

  const onFinish = async values => {
    const res = await updateShift(
      shift.id,
      {
        bookRequests: [
          ...shift.bookRequests,
          {
            confirmedPlayers: values.confirmedPlayers,
            public: isPublic,
            userId: user.uid,
            userName: user.displayName,
            userPhotoUrl: user.photoURL,
          },
        ],
      },
      setLoading,
    );
    if (res) {
      onClose();
    }
  };
  const onFinishFailed = values => {};

  return (
    <Modal
      title="Reservar Partido"
      visible={visible}
      onOk={form.submit}
      okButtonProps={{ loading: loading }}
      onCancel={onClose}>
      <Card>
        <Descriptions size="small" layout="vertical" title={placeSport}>
          <Descriptions.Item>{`${placeName}: ${address}`}</Descriptions.Item>
          <Descriptions.Item>{`Jugadores: ${totalPlayers}`}</Descriptions.Item>
          <Descriptions.Item span={2}>
            {getDateFromTimestamp(startDate)}
          </Descriptions.Item>
        </Descriptions>
      </Card>
      <Form
        form={form}
        name="basic"
        layout="vertical"
        labelCol={{
          span: 10,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={{
          remember: false,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off">
        <Form.Item label="Publico" name="public">
          <Space.Compact>
            <Switch
              size="small"
              defaultChecked
              checked={isPublic}
              onChange={() => setIsPublic(!isPublic)}
            />
          </Space.Compact>
        </Form.Item>

        <Form.Item
          label="Jugadores Confirmados"
          name="confirmedPlayers"
          rules={[
            {
              required: true,
              message: 'Indique la cantidad de jugadores del partido!',
            },
          ]}>
          <Space.Compact>
            <InputNumber
              min={1}
              max={totalPlayers}
              defaultValue={totalPlayers}
              onChange={value =>
                form.setFieldsValue({
                  confirmedPlayers: value,
                })
              }
            />
          </Space.Compact>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default BookShiftModal;
